export default __webpack_public_path__ + "static/media/qr-code.5c2fc9be.svg";